import * as React from "react";
import { twMerge } from "tailwind-merge";
import { Description } from "@/components/Field";
import { Heading } from "@/components/Heading";

export interface FormSectionProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  showDivider?: boolean;
}

export function FormSection({ title, description, showDivider, className, children, ...rest }: FormSectionProps) {
  return (
    <section {...rest} className={twMerge("flex flex-col", className)}>
      {(title || description) && (
        <div className="flex flex-col gap-1 mb-6">
          {typeof title === "string" ? (
            <Heading tag="h3" size="sm">
              {title}
            </Heading>
          ) : (
            title
          )}
          {description ? <Description size="lg">{description}</Description> : null}
        </div>
      )}
      <div className="flex flex-col gap-6">{children}</div>
      {showDivider && <hr className="mt-2 border-border-muted" />}
    </section>
  );
}

export function FormDivider() {
  return <hr className="border-border-muted" />;
}
